import React, { useEffect, useState } from "react";

const MAINTENANCE_START = process.env.REACT_APP_MAINTENANCE_START;
const MAINTENANCE_END = process.env.REACT_APP_MAINTENANCE_END;

const features = [
//   "🔒 ปลอดภัย & สำรองข้อมูล",
//   "⚡ ปรับปรุงประสิทธิภาพ",
//   "✨ ฟีเจอร์ใหม่เร็วๆ นี้",
];

function getTimeLeft(target) {
  const now = new Date();
  let diff = target.getTime() - now.getTime();
  if (diff <= 0) return { days: 0, hours: 0, mins: 0, secs: 0 };
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  diff -= days * (1000 * 60 * 60 * 24);
  const hours = Math.floor(diff / (1000 * 60 * 60));
  diff -= hours * (1000 * 60 * 60);
  const mins = Math.floor(diff / (1000 * 60));
  diff -= mins * (1000 * 60);
  const secs = Math.floor(diff / 1000);
  return { days, hours, mins, secs };
}

function MaintenancePage({ supportEmail, logoText, companyName }) {
  const startDate = React.useMemo(() => new Date(MAINTENANCE_START), []);
  const endDate = React.useMemo(() => new Date(MAINTENANCE_END), []);
  const [timeLeft, setTimeLeft] = useState(getTimeLeft(endDate));
  const maintenanceHours = Math.round((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60));

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeLeft(endDate));
    }, 1000);
    return () => clearInterval(timer);
  }, [endDate]);

  return (
    <main className="min-h-screen flex items-center justify-center bg-gradient-to-b from-[#0f172a] to-[#0b1220] px-4 py-8 relative overflow-hidden">
      {/* Glassmorphism background shapes */}
      <div className="absolute -top-32 -left-32 w-[420px] h-[420px] rounded-full bg-purple-500 opacity-30 blur-3xl animate-pulse z-0" />
      <div className="absolute -bottom-32 -right-32 w-[380px] h-[380px] rounded-full bg-cyan-400 opacity-20 blur-3xl animate-pulse z-0" />
      <section className="relative z-10 w-full max-w-2xl bg-white/5 rounded-2xl shadow-2xl p-6 md:p-10 flex flex-col items-center gap-6 border border-white/10 backdrop-blur-md">
        {/* Main message */}
        <div className="flex flex-col items-center w-full">
          <div className="flex items-center gap-4 mb-2 justify-center">
            <div className="w-14 h-14 rounded-xl bg-white/10 flex items-center justify-center font-bold text-lg text-white shadow-lg animate-[floaty_4s_ease-in-out_infinite]">
              <img src="/favicon-32x32.png" alt="Logo" className="w-8 h-8" />
            </div>
            <div>
              <div className="text-xs text-slate-400 font-semibold text-center md:text-left">เว็บไซต์กำลังปรับปรุง</div>
              <h1 className="text-2xl md:text-3xl font-bold tracking-tight text-white text-center md:text-left" id="headline">
                เรากำลังปรับปรุงระบบ — จะกลับมาเร็วๆ นี้
              </h1>
            </div>
          </div>
          <p className="text-slate-300 mt-2 mb-4 leading-relaxed text-center">
            ขออภัยในความไม่สะดวก ทีมงานของเรากำลังปรับปรุงประสิทธิภาพของระบบ หากต้องการติดต่อเราด่วน กรุณาส่งอีเมลมาที่ <strong>{supportEmail}</strong>
          </p>
          {/* <div className="flex flex-wrap gap-2 mb-3 justify-center">
            {features.map((f, i) => (
              <span key={i} className="bg-white/10 text-slate-100/90 px-3 py-1 rounded-full text-xs font-medium border border-white/10">
                {f}
              </span>
            ))}
          </div> */}
          {/* Maintenance Info above countdown */}
          <div className="flex flex-col items-center gap-1 mt-4 mb-2">
            <span className="text-xs text-cyan-300 font-bold">กำหนดการปรับปรุงระบบ</span>
            <span className="text-xs text-white">ตั้งแต่วันที่ <span className="text-cyan-300 font-bold">{startDate.toLocaleString('th-TH', { hour: '2-digit', minute: '2-digit', day: '2-digit', month: '2-digit', year: 'numeric' })}</span> ถึง <span className="text-cyan-300 font-bold">{endDate.toLocaleString('th-TH', { hour: '2-digit', minute: '2-digit', day: '2-digit', month: '2-digit', year: 'numeric' })}</span></span>
            <span className="text-xs text-yellow-300">ใช้เวลาปรับปรุงโดยประมาณ {maintenanceHours} ชั่วโมง</span>
          </div>
          {/* Countdown */}
          <div className="flex gap-3 font-bold text-white text-base justify-center" aria-live="polite">
            <div className="min-w-[72px] bg-white/10 p-3 rounded-lg text-center border border-white/10">
              <div className="text-xl font-mono">{timeLeft.days}</div>
              <div className="text-xs text-slate-400 font-semibold mt-1">วัน</div>
            </div>
            <div className="min-w-[72px] bg-white/10 p-3 rounded-lg text-center border border-white/10">
              <div className="text-xl font-mono">{String(timeLeft.hours).padStart(2, "0")}</div>
              <div className="text-xs text-slate-400 font-semibold mt-1">ชั่วโมง</div>
            </div>
            <div className="min-w-[72px] bg-white/10 p-3 rounded-lg text-center border border-white/10">
              <div className="text-xl font-mono">{String(timeLeft.mins).padStart(2, "0")}</div>
              <div className="text-xs text-slate-400 font-semibold mt-1">นาที</div>
            </div>
            <div className="min-w-[72px] bg-white/10 p-3 rounded-lg text-center border border-white/10">
              <div className="text-xl font-mono">{String(timeLeft.secs).padStart(2, "0")}</div>
              <div className="text-xs text-slate-400 font-semibold mt-1">วินาที</div>
            </div>
          </div>
          {/* <p className="text-xs text-slate-400 mt-4 text-center">หมายเหตุ: วันที่ที่แสดงเป็นการประเมิน — เว็บไซต์อาจกลับมาเร็วกว่าที่คาด.</p> */}
          <p className="text-xs text-slate-400 mt-2 text-center">© {new Date().getFullYear()} {companyName} — All rights reserved</p>
        </div>
      </section>
    </main>
  );
}

export default MaintenancePage;
